<template>
    <v-row :class="['card-container pa-3', {'container-active': isActive}]" align="center" v-if="plan">
        <v-col cols="12" v-if="isActive" class="py-0" align="right">
            <div class="hired-container">
                {{ stepperMode ? $t('common.selected') : $t('common.hired') }}
            </div>
        </v-col>
        <v-col cols="4" class="text-center">
            <div :class="['img-container', {'img-active': isActive}]">
                <v-img :src="planImg" max-width="46" class="mx-auto"/>
            </div>
        </v-col>
        <v-col cols="8" :class="['plan-name', {'white--text': isActive}]">
            {{ plan.name }}
        </v-col>
        <v-col cols="12" class="text-center">
            <span :class="['plan-price', {'white--text': isActive}]">
                {{ planAmount }} {{ plan.currency }}
            </span>
            <div :class="['card-text text-uppercase', {'text-active': isActive}]">
                {{ plan.interval }}
            </div>
        </v-col>
        <v-col cols="12" :class="['card-text py-0', {'text-active': isActive}]">
            {{ $t('common.include') }}
        </v-col>
        <v-col cols="12" :class="['card-text', {'text-active': isActive}]">
            <v-row v-for="(feature,i) in features" :key="i" dense align="center">
                <v-col cols="2" class="text-center">
                    <v-avatar color="#99CC00" size="25">
                        <v-icon color="#FFFFFF" size="17">$check</v-icon>
                    </v-avatar>
                </v-col>
                <v-col cols="10">
                    {{ feature }}
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" v-if="!isActive">
            <v-btn class="b-contract" block @click="contractPlan" depressed>
                {{ $t('common.contract') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: "SubscriptionCard",
    props: {
        plan: {
            type: Object,
            default: null
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        discount: {
            type: Number,
            default: null
        },
        stepperMode: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        planImg(vm = this) {
            return vm.plan?.img || vm.imgPlaceholder
        },
        features(vm = this) {
            let features = []
            if (!vm.plan) return features
            if (vm.plan.premium) features.push(vm.$t('common.premium_support'))
            features.push(vm.plan.maxClients ? vm.$t('common.max_clients', {max: vm.plan.maxClients}) : vm.$t('common.unlimited_clients'))
            features.push(
                vm.$t('plan_features.groups'),
                vm.$t('plan_features.upload_exercises'),
                vm.$t('plan_features.fast_training'),
                vm.$t('plan_features.save_all_training'),
                vm.$t('plan_features.copy_training'),
                vm.$t('plan_features.chat_with_students'),
                vm.$t('plan_features.statistics'),
                vm.$t('plan_features.charge_evaluations'),
            )
            return features
        },
        planAmount(vm = this) {
            if(!vm.discount) return vm.plan.amount
            return Number(vm.plan.amount - ((vm.plan.amount * vm.discount) / 100)).toFixed(1)
        },
    },
    async mounted() {
        const vm = this
    },
    methods: {
        contractPlan() {
            const vm = this
            vm.$emit('plan', vm.plan)
        }
    }
}
</script>

<style scoped>

.card-container {
    background: #FFFFFF;
    border: 1px solid #EFF0F7;
    box-shadow: 0px 2px 12px rgba(20, 20, 43, 0.08);
    border-radius: 24px;
}

.img-container {
    display: inline-block;
    background: #F0FFE0;
    border-radius: 16px;
    padding: 4px;
}

.card-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #170F49;
}

.plan-name {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #170F49;
}

.plan-price {
    font-weight: 700;
    font-size: 36px;
    line-height: 40px;
    color: #170F49;
}

.b-contract {
    height: 52px !important;
    background: #99CC00 !important;
    border-radius: 96px;
    text-transform: none;
    color: #ffffff;
    font-weight: 700 !important;
    font-size: 18px;
    line-height: 20px;
}

.container-active {
    background: #333333;
}

.img-active {
    background: #FFFFFF;
}

.text-active {
    color: #EFF0F7;
}

.hired-container {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 9px;
    color: #FFFFFF;
    font-size: 12px;
    line-height: 12px;
    padding: 6px 9px;
    display: inline-block;
}

</style>